import useEntity from "../../hooks/useLocation";
import LocationDetail from "../../components/location/LocationDetail/LocationDetail";
import LocationScoped from "../../components/location/LocationDetail/LocationScoped";
import LocationTabs from "../../components/location/LocationDetail/LocationTabs";
import { useGetLocationQuery } from "../../apis/Location.api";
import { PrimaryLocation } from "../../types/models/Location";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const LocationDetailPage = () => {

    useTitle(t`Details Location`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { locationId: id } = useParams();

    const { data, refetch } = useGetLocationQuery(PrimaryLocation.fromPath(id))
    const { deleteLocation } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteLocation(data, '..')
    }, [data, deleteLocation])

    if (id === 'scoped') {
        return (<LocationScoped/>)
    }

    return (
        <Box data-testid="Location-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <LocationDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/location/entities/Locations/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="Location-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/location/entities/Locations/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="Location-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <LocationTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default LocationDetailPage;
